import { render, staticRenderFns } from "./PendingApplications.vue?vue&type=template&id=1a5f3f79"
import script from "./PendingApplications.vue?vue&type=script&lang=js"
export * from "./PendingApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports